/* src/app/views/dashboard/components/sidebar-nav/nav-sub-item/universal-variants-sub-nav-item/universal-variants-sub-nav-item.component.scss */
/*# sourceMappingURL=universal-variants-sub-nav-item.component.css.map */
